// extracted by mini-css-extract-plugin
export default {"stuckGrid":"StuckGrid_stuckGrid__5ccdk"};